// @flow
import './index.less';

import React from 'react';

import useBreakpoint from '_hooks/useBreakpoint';
import Logo from '_images/sphere_logo.png';
import HomeCircles from '_images/sphere_splash_circles.png';
import HomeCirclesMobile from '_images/sphere_splash_circles_mobile.png';

type Props = {
  title: React$Node,
  description?: string,
  backgroundImage?: number | string,
  backgroundColor?: string,
};

const ComingSoonSection = ({title, description, backgroundImage, backgroundColor}: Props): React$Node => {
  const isMobile = useBreakpoint({max: 'md'});
  return (
    <>
      <img src={isMobile ? HomeCirclesMobile : HomeCircles} className="sphere-circles" alt="cirlces" />

      <section className="header">
        <div className="container">
          <div className="logo">
            <img src={Logo} alt="Sphere Logo" />
          </div>
          <div style={{maxWidth: '550px'}}>
            <p className="subtitle">A new vision for self-optimisation and mastery of body and mind.</p>
            <p className="address">Launching Mid 2022 · 137 Cecil Street, Singapore</p>
            {/* <h2>JOIN THE MAILING LIST</h2>
            <p className="mailinglist">Be the first to know when Sphere launches and get access to special offers.</p>
           
            <form name="Mailing List" method="POST" data-netlify="true" action="/thankyou">
              <input type="hidden" name="form-name" value="Mailing List" />
              <div className="form-wrapper">
                <input type="email" name="email" placeholder="Enter your email" />
                <button type="submit">Submit</button>
              </div>
            </form> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default ComingSoonSection;
